export enum PaymentsConfigurationFieldName {
    RetentionPolicyDays = 'retentionPolicyDays',
    IsCardSharingEnabled = 'isCardSharingEnabled',
}
